import React from 'react';
import { action, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';

import type { IModalDialogContent, ModalDialogOptions, ModalWindow } from '@components/Modal.tsx';
import { ModalButtonType } from '@components/Modal.tsx';

@observer
export class CreateFolderDialog extends React.Component implements IModalDialogContent<string> {
  @observable private _name = '';

  constructor(props: {}) {
    super(props);
    makeObservable(this);
  }

  getModalOptions(window: ModalWindow<string>): ModalDialogOptions<string> {
    return {
      title: 'New Folder',
      width: '400px',
      closeByEscape: true,
      closeOnClickOutside: true,
      buttons: [
        {
          title: 'Create',
          type: ModalButtonType.Add,
          color: 'primary',
          onClick: () => {
            const name = this._name.trim();
            if (name) {
              window.setPayload(name);
              window.close(ModalButtonType.Add);
            }
          },
        },
        {
          title: 'Cancel',
          type: ModalButtonType.Cancel,
          onClick: () => window.close(ModalButtonType.Cancel),
        },
      ],
    };
  }

  render() {
    return (
      <div>
        <input
          type="text"
          className="form-control"
          placeholder="Folder name"
          value={this._name}
          onChange={this._onChange}
          autoFocus
        />
      </div>
    );
  }

  @action.bound
  private _onChange(e: React.ChangeEvent<HTMLInputElement>) {
    this._name = e.target.value;
  }
}
